import { useThankYouTariffSummary } from '@in-life/hooks';
import { inLifePaths } from '@in-life/paths';
import { clearInLifeOrderAndRedirectToMyAccount } from '@in-life/utils/clearInLifeOrder';
import { Button, Flex, Heading } from '@utilitywarehouse/hearth-react';
import { Navigate } from 'react-router-dom';

import { NumberedList } from '@components/NumberedList';

import { ThankYouHero } from './ThankYouHero';
import './styles.scss';
import { useThankYouTracking } from './useThankYouTracking';

const ThankYou = () => {
  const {
    basketId,
    tariffTitle,
    tariffSubtitle,
    price,
    isLoading,
    hasError,
    hasData,
  } = useThankYouTariffSummary();
  useThankYouTracking({ basketId, isReady: !isLoading });

  const handleBackToHome = () => {
    clearInLifeOrderAndRedirectToMyAccount();
  };

  if (!isLoading && !hasData) {
    return <Navigate to={inLifePaths.orderConfirm} replace />;
  }

  return (
    <div data-testid="inlife-thank-you">
      <ThankYouHero
        tariffTitle={tariffTitle}
        tariffSubtitle={tariffSubtitle}
        price={price}
        isLoading={isLoading}
        hasError={hasError}
      />
      <div className="wrapper">
        <Flex direction="column" gap="200" marginBottom="500" marginRight="100">
          <Heading as="h2" marginBottom="100">
            What happens next...
          </Heading>
          <NumberedList
            items={[
              {
                title: "We'll drop a confirmation email in your inbox shortly.",
                description:
                  "Keep an eye out for it - it's got all your key details.",
              },
              {
                title: "We'll handle the switch with your old provider.",
                description:
                  "No awkward conversations needed. You don't need to lift a finger or call them up.",
              },
              {
                title: 'Most switches go live in a few days.',
                description:
                  "Some can take just a bit longer, but don't worry - we'll keep you updated every step of the way.",
              },
              {
                title: 'Your dashboard will update soon.',
                description:
                  'It can take a little time for your energy info to pop up, but rest assured, everything is working away behind the scenes.',
              },
            ]}
          />

          <Flex justifyContent="start">
            <Button
              variant="outline"
              data-testid="inlife-thank-you-back-to-home"
              onClick={handleBackToHome}
            >
              Back to home
            </Button>
          </Flex>
        </Flex>
      </div>
    </div>
  );
};

export { ThankYou };
